import request from '@/utils/request';

export async function getStudentInfo() {
  const res = await request({
    url: `/system/student/getSchoolStudentInfo`,
    method: 'get',
  })
  const VUE_X_KEY = "vuex"
  const origin = JSON.parse(localStorage.getItem(VUE_X_KEY) || '{}')

  const combined = { // 合并必要的数据
    ...origin,
    auth: {
      ...(origin.auth || {}),
      newUser: {
        ...res.data,
      },
    }
  }
  localStorage.setItem(VUE_X_KEY, JSON.stringify(combined)) // 存Nuxt用到的Vuex数据
  return res
}

export function updateStudentInfo(data) {
    return request({
        url: `/system/student/update`,
        method: 'post',
        data
    })
}


export function updatePassWord(data) {
    return request({
        url: `/system/student/updatePassWord`,
        method: 'post',
        data
    })
}

export function addStudentAddress(data) {
    return request({
        url: `/system/student/addStudentAddress`,
        method: 'post',
        data
    })
}
